import { render } from "./AppNotFounds.vue?vue&type=template&id=47ebbf29"
import script from "./AppNotFounds.vue?vue&type=script&lang=js"
export * from "./AppNotFounds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__